// This import loads the firebase namespace along with all its type information.
import RawMetric from './raw-metric-model'

export async function load_rawMetrics(): Promise<RawMetric[]> {
  throw 'Not implemented'
}

export async function delete_rawMetric(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_rawMetric(): Promise<RawMetric> {
  throw 'Not implemented'
}
